<template>
  <m-geo-box geo-option='state'>
    <div class='box-t'>
      <div class='header'>
        <h3>State List</h3>
          <m-geo-state-menu></m-geo-state-menu>
      </div>
    </div>
  </m-geo-box>

</template>

<script>
  import MGeoBox from '@/components/geo/MGeoBox'
  import MGeoStateMenu from '@/components/geo/MGeoStateMenu'

  export default {
    components: {
      MGeoBox,
      MGeoStateMenu
    },
    data () {
      return {
      }
    }
  }
</script>

<style scoped lang='scss'>
  .box-t{
    border: 1px solid #ccc;
    border-radius: 8px;
    background-color: $color-background;
    padding: 16px;
    width: 100%;
    margin-bottom:16px;
    display: block;
  }

</style>



// WEBPACK FOOTER //
// src/pages/order/GeoStateMap.vue